import styled from "styled-components";
import { SelectInput } from "@streeteasy/design-system";
import { GRAY_LIGHTEST } from "@streeteasy/design-system/colors";
import colorPalette from "@streeteasy/design-system/deprecated/colors";

export const Form = styled.form`
  margin-bottom: 2px;
`;

export const Select = styled(SelectInput)`
  appearance: none;
  background: ${GRAY_LIGHTEST};
  border: none;
  color: ${colorPalette.goatGrey};
  font-size: 12px;
  font-weight: bold;
  height: 50px;
  padding: 10px 100px 10px 70px;
  white-space: nowrap;
`;
